/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {


var slides = document.getElementsByClassName('slideshow__slide');
  
var redirectOnClick = function() {
    var attribute = this.getAttribute("data-link");
    window.location.href = attribute;
};

for (var i = 0; i < slides.length; i++) {
    slides[i].addEventListener('click', redirectOnClick, false);
}

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
